import { RestClient, RequestResponse } from "@infrastructure/clients/http/clients/base/rest.client";
import { CommonDto } from "@infrastructure/clients/http/common.dto";
import { BASE_URL } from "@infrastructure/clients/http/config";
import {
  SendLocationRequestSchema,
  LocationResponseSchema
} from "@infrastructure/clients/http/clients/geo.schemas";
import * as z from "zod";

class GeoClientClass extends RestClient {
  baseUrl = BASE_URL;

  async sendLocation(latitude: number, longitude: number, city?: string | null): Promise<RequestResponse<z.infer<typeof LocationResponseSchema>>> {
    const result = await this.request(
      "POST",
      "/api/location",
      {
        jsonPayload: { latitude, longitude, ...(city !== undefined && { city }) },
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(LocationResponseSchema));
  }
}

export class GeoClient extends GeoClientClass {}
